import React, { useCallback } from "react";
import { FiShare2 } from "react-icons/fi";
import Swal from "sweetalert2";
import { Color } from "../utils/theme";
import {
  buildCatalogShareMessage,
  buildPublicCatalogUrl,
  buildWhatsAppShareUrl,
  getCatalogShopSlug,
  getCatalogVendeur,
} from "./catalogTenant";

export default function CatalogShareFab() {
  const handleShare = useCallback(async () => {
    const slug = getCatalogShopSlug();
    if (!slug) return;

    const url = buildPublicCatalogUrl(slug);
    const vendeur = getCatalogVendeur();
    const shopName =
      vendeur?.nom_boutique ||
      vendeur?.nom_de_la_boutique ||
      "Ma boutique";
    const shareMessage = buildCatalogShareMessage(shopName, url);

    const result = await Swal.fire({
      title: `Catalogue ${shopName}`,
      text: "Partagez votre boutique en ligne.",
      showCancelButton: true,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "WhatsApp",
      denyButtonText: "Copier le lien",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#25D366",
      denyButtonColor: Color.themeColor,
      iconColor: Color.themeColor,
    });

    if (result.isConfirmed) {
      window.open(
        buildWhatsAppShareUrl(shareMessage),
        "_blank",
        "noopener,noreferrer",
      );
      return;
    }

    if (result.isDenied) {
      try {
        await navigator.clipboard.writeText(shareMessage);
        Swal.fire({
          icon: "success",
          title: "Lien copié !",
          text: "Le message de partage a été copié dans le presse-papiers.",
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 2000,
        });
      } catch {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Impossible de copier le lien pour le moment.",
          iconColor: Color.danger,
        });
      }
    }
  }, []);

  return (
    <button
      type="button"
      className="catalog-share-fab"
      onClick={handleShare}
      title="Partager le catalogue"
      aria-label="Partager le catalogue"
    >
      <FiShare2 size={22} color="#fff" />
    </button>
  );
}
